export const getObjectValues = (t) => Object.values(t);
